<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Список пользователей</div>
            <a class="title-block__btn btn-add btn-primary btn" href="/access-add-user">Добавить </a>
        </div>
        <div class="title-block__right d-none d-md-flex">
            <div class="title-block__amount">30 записей</div>
        </div>
    </div>
    <div class="filter-table">
        <div class="filter-table__input-wrap search-control"><input type="text" class="search-control__input form-control"
                placeholder="Поиск">
            <button class="search-control__input-btn reset-btn">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 8.333a5.834 5.834 0 1011.667 0 5.834 5.834 0 00-11.667 0zM17.5 17.5l-5-5"
                        stroke="currentColor" stroke-width="1.667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
        <div class="filter-table__list-wrap">
            <ul class="filter-table__list">
                <li class="filter-table__item">
                    <v-select style="width: 240px"
                        v-model="primaryFilterVal"
                        :items="primaryFilterList"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        clearable
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </li>
                <li class="filter-table__item" v-show="primaryFilterVal === 'Категории доступа'">
                    <v-select style="width: 240px"
                        v-model="categoryFilterVal"
                        :items="categoryFilterList"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        clearable
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </li>
                <li class="filter-table__item" v-show="primaryFilterVal === 'Группы пользователей'">
                    <v-select style="width: 240px"
                        v-model="groupFilterVal"
                        :items="groupFilterList"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        clearable
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </li>
            </ul>
        </div>
    </div>
    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>Имя пользователя</th>
                    <th>Роль</th>
                    <th>Группа</th>
                    <th>Почта</th>
                    <th>Действия</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Иванов Петр</td>
                    <td>Клиент</td>
                    <td>Клиентовая</td>
                    <td>secretar@neo-pharm.ru</td>
                    <td>
                        <div class="table-actions">
                            <button class="table-action table-action_edit" title="Редактировать" type="button"></button>
                            <button class="table-action table-action_delete" title="Удалить" type="button"></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- Замените на компонент навигации -->
    <nav aria-label="Пример навигации по страницам">
        <ul class="pagination justify-content-center pt-4">
            <li class="page-item disabled">
                <a class="page-link page-link_prev"><svg width="7" height="11" viewBox="0 0 7 11" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 0.5L1 5.5L6 10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                    </svg>
                </a>
            </li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item active"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item">
                <a class="page-link page-link_next" href="#">
                    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 0.5L6 5.5L1 10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                    </svg>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
import { withPopper } from '../../../utilites.js';
export default {
    name: "AccessUserList",
    data: () => {
        return {
            primaryFilterVal: 'Все',
            categoryFilterVal: 'Управление и администрирование',
            groupFilterVal: 'Клиентовая',
            primaryFilterList: [
                'Все',
                'Категории доступа',
                'Группы пользователей'
            ],
            categoryFilterList: [
                'Управление и администрирование',
                'Клиентский',
                'Корпоративный'
            ],
            groupFilterList: [
                'Клиентовая',
                'Проектный отдел',
                'Отдел десктоп решений',
                'Отдел административного управления',
                'Управление и администрирование'
            ],
        };
    },
    methods: {
        withPopper
    },
};
</script>
